import { ROUTES } from '@constants'
import { NavigateOptions, useNavigate } from 'react-router-dom'

const useNavigation = () => {
  const navigate = useNavigate()

  const goToPlantList = (options?: NavigateOptions) => navigate(ROUTES.PLANT_LIST, options)
  const goToPlantDetail = (plantId: string, options?: NavigateOptions) =>
    navigate(ROUTES.PLANT_DETAIL.replace(':plantId', plantId), options)

  const goToDashboard = (options?: NavigateOptions) => navigate(ROUTES.DASHBOARD, options)
  const goToSummary = (options?: NavigateOptions) => navigate(ROUTES.SUMMARY, options)

  const goToAdminDashboard = (options?: NavigateOptions) => navigate(ROUTES.ADMIN_DASHBOARD.LIST, options)
  const goToAdminDashboardDetail = (dashboardId: string, options?: NavigateOptions) =>
    navigate(ROUTES.ADMIN_DASHBOARD.DETAIL.replace(':dashboardId', dashboardId), options)
  const goToAdminDashboardList = (options?: NavigateOptions) => navigate(ROUTES.ADMIN_DASHBOARD.LIST, options)

  return {
    goToPlantList,
    goToPlantDetail,
    goToDashboard,
    goToSummary,
    goToAdminDashboard,
    goToAdminDashboardDetail,
    goToAdminDashboardList,
  }
}

export default useNavigation
